export const GAP = 12
export const SAFETY_MARGIN = 2
export const CONTAINER_PADDING = 8

export function sumWidth(widths, gap = GAP) {
  return widths.reduce((sum, width, index) => sum + width + (index ? gap : 0), 0)
}

/**
 * Decide how many leading items stay visible. Overflow goes into More, from right to left.
 *
 * - If every item fits, show them all (no More).
 * - Otherwise keep More, then drop the last visible item until the remainder fits.
 * - If even the first item plus More cannot fit, hide every item in More.
 */
export function planOverflow({
  availableWidth,
  itemWidths,
  moreWidth,
  gap = GAP,
  safetyMargin = SAFETY_MARGIN
}) {
  const n = itemWidths.length
  if (!n) return 0

  if (sumWidth(itemWidths, gap) + safetyMargin <= availableWidth) return n

  for (let count = n - 1; count >= 1; count--) {
    const total = sumWidth(itemWidths.slice(0, count), gap) + gap + moreWidth
    if (total + safetyMargin <= availableWidth) return count
  }

  return 0
}
